import { forwardRef } from 'react';

import { Button } from '@wwe-portal/ui/components/button';

import type { PlayerRosterForClubStore } from '@wwe-portal/entities/roster.type';
import { useResponsive } from '@wwe-portal/ui/hooks/use-responsive';

import { BodyGrid, BodyList } from './body';
import { Header } from './header';

export interface PlayerRosterSectionProps {
  isLoading?: boolean;
  title: string;
  description: string;
  rosters?: PlayerRosterForClubStore[];
  onItemClick: (id: string) => void;
  total?: number;
  onViewMoreRosters: () => void;
  ref?: React.Ref<HTMLDivElement> | undefined;
}

export const PlayerRosterSection = forwardRef<
  HTMLDivElement,
  PlayerRosterSectionProps
>(function ChildComponent(
  {
    isLoading,
    title,
    description,
    total,
    rosters,
    onItemClick,
    onViewMoreRosters,
  },
  ref: React.Ref<HTMLDivElement>
) {
  const { isMobile } = useResponsive();
  const List = isMobile ? BodyList : BodyGrid;

  return (
    <div data-id="fuseup-section" ref={ref}>
      <div className="flex w-full flex-col gap-[12px]">
        <Header description={description} title={title} total={total} />
        <List data={rosters} loading={isLoading} onItemClick={onItemClick} />
      </div>
      {rosters && total != null && total > rosters.length && (
        <div className="flex w-full justify-center pt-3 md:pt-5">
          <Button
            className="h-[44px] w-full font-semibold md:w-[200px]"
            onClick={onViewMoreRosters}
            variant="secondary"
          >
            View More
          </Button>
        </div>
      )}
    </div>
  );
});
